module.exports = __webpack_public_path__ + "img/grid-img-6.jpg";